const ACTION_TYPES = {
    protest: '#dc2626',
    community_action: '#2563eb',
    mutual_aid: '#16a34a'
  };
  
  export default ACTION_TYPES;